import React, {useEffect} from 'react';

export function HardRefreshToServer() {
  useEffect(() => {
    window.location.reload();
  }, []);

  return <div></div>;
}
